import axios from "axios";
import { TTP_API_URL } from "../config";

export const getPeriodFinancialSheetTree = (token, organizationId, payload) => {
  const requestUrl = `${TTP_API_URL}/team/financials-period`;

  let params = {
    access_token: token,
    organizationId,
    partner: payload.partner,
    partnerZone: payload.partnerZone,
    clientCRMTypes: JSON.stringify(payload.clientCRMTypes),
    clientCRMGroup: JSON.stringify(payload.clientCRMGroup),
    isEntity: payload.isEntity,
    collaborators: payload.collaborators,
    period: payload.year,
    // businessUnits: businessUnits.map(({ value }) => value),
    sortBy: payload.sortBy,
    searchWord: payload.keyWord,
    withBudgetaryBenchmark: true,
    deletedStatus: payload.deletedStatus,
    startDate:
      payload.period.id === "ANNUAL"
        ? payload.period.start
        : payload.subPeriod.start,
    endDate:
      payload.period.id == "ANNUAL"
        ? payload.period.end
        : payload.subPeriod.end,
    term: payload.period.id,
  };

  params.limit = payload.pageSize || 10;
  params.start = !payload.page ? 0 : (payload.page - 1) * payload.pageSize;

  return axios.get(requestUrl, {
    params,
  });
};

export const getPeriodFinancialTotal = (token, organizationId, payload) => {
  const requestUrl = `${TTP_API_URL}/team/financials-period-total`;
  let params = {
    access_token: token,
    organizationId,
    partner: payload.partner,
    partnerZone: payload.partnerZone,
    clientCRMTypes: JSON.stringify(payload.clientCRMTypes),
    clientCRMGroup: JSON.stringify(payload.clientCRMGroup),
    isEntity: payload.isEntity,
    collaborators: payload.collaborators,
    period: payload.year,
    // businessUnits: businessUnits.map(({ value }) => value),
    sortBy: payload.sortBy,
    searchWord: payload.keyWord,
    withBudgetaryBenchmark: true,
    deletedStatus: payload.deletedStatus,
    startDate:
      payload.period.id === "ANNUAL"
        ? payload.period.start
        : payload.subPeriod.start,
    endDate:
      payload.period.id == "ANNUAL"
        ? payload.period.end
        : payload.subPeriod.end,
    term: payload.period.id,
  };

  params.limit = payload.pageSize || 10;
  params.start = !payload.page ? 0 : (payload.page - 1) * payload.pageSize;

  return axios.get(requestUrl, {
    params,
  });
};

export const getErpData = (token, organizationId, collaborators) => {
  const requestUrl = `${TTP_API_URL}/team/erp-data`;
  let params = {
    access_token: token,
    organizationId,
    // clients: clients.map(({ value }) => value),
    collaborators: collaborators.map(({ value }) => value),
  };

  return axios.get(requestUrl, {
    params,
  });
};

export const exportPeriodFinancialSheet = async (
  token,
  organizationId,
  clients,
  clientGroups,
  collaborators,
  year,
  squads,
  clusters,
  businessUnits,
  sortBy,
  searchWord,
  withBudgetaryBenchmark,
  clientTypes,
  budgetStatus,
  clientCRMTypes,
  clientCRMGroup,
  collaboratorRole,
  deletedStatus,
  offshoreStatus,
  facturableStatus,
  isEntity
) => {
  const requestUrl = `${TTP_API_URL}/team/export/financials-period`;
  let params = {
    access_token: token,
    organizationId,
    clients: clients.map(({ value }) => value),
    clientGroups,
    collaborators: collaborators.map(({ value }) => value),
    period: year,
    squads: squads.map(({ value }) => value),
    clusters: clusters.map(({ value }) => value),
    businessUnits: businessUnits.map(({ value }) => value),
    clientTypes: JSON.stringify(clientTypes),
    clientCRMTypes: JSON.stringify(clientCRMTypes),
    sortBy: sortBy,
    searchWord: searchWord,
    withBudgetaryBenchmark,
    budgetStatus: budgetStatus,
    facturableStatus: facturableStatus,
    groupDescriptions: JSON.stringify(clientCRMGroup),
    collaboratorRole,
    isEntity: isEntity,
    deletedStatus,
    offshoreStatus,
  };

  return await axios
    .get(requestUrl, {
      params,
      responseType: "blob",
      headers: { Accept: "application/vnd.ms-excel" },
    })
    .then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.data.type })
      );
      const link = document.createElement("a");
      link.href = url;
      let date = new Date();
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let dateString =
        day +
        "-" +
        month +
        "-" +
        date.getFullYear() +
        " " +
        date.getHours() +
        "-" +
        minutes +
        "-" +
        seconds;
      link.setAttribute(
        "download",
        "PowerTeam Financial-sheet " + dateString + ".xlsx"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};

export const importFinancialSheet = ({
  importAttachment,
  data,
  importedYear,
}) => {
  const requestUrl = `${TTP_API_URL}/team/financial/import`;

  var formData = new FormData();

  formData.append("organizationId", data);

  formData.append("importedYear", importedYear);

  if (importAttachment instanceof File) {
    formData.append("file", importAttachment, importAttachment.name);
  }

  return axios.post(requestUrl, formData);
};

export const getPeriodFinancialList = (token, organizationId, payload) => {
  const requestUrl = `${TTP_API_URL}/team/financial-delta-list`;

  let params = {
    access_token: token,
    organizationId,
    partner: payload.partner,
    partnerZone: payload.partnerZone,
    collaborators: payload.collaborators,
    billingType: payload.billingType,
    year: payload.year,
    searchWord: payload.keyWord,
    deletedStatus: payload.deletedStatus,
  };

  params.limit = payload.pageSize || 10;
  params.start = !payload.page ? 0 : (payload.page - 1) * payload.pageSize;

  return axios.get(requestUrl, {
    params,
  });
};

export const getMonthFinancial = (token, organizationId, payload) => {
  const requestUrl = `${TTP_API_URL}/team/financial-period-data`;

  let params = {
    access_token: token,
    organizationId,
    partner: payload.partner,
    partnerZone: payload.partnerZone,
    year: payload.year,
    clients: payload.clients,
  };

  return axios.get(requestUrl, {
    params,
  });
};

export const getFinancialFollowUp = (token, organizationId, payload) => {
  const requestUrl = `${TTP_API_URL}/team/financial-follow-up`;

  let params = {
    access_token: token,
    organizationId,
    partner: payload.partner,
    partnerZone: payload.partnerZone,
    year: payload.year,
    clients: payload.clients,
  };

  return axios.get(requestUrl, {
    params,
  });
};

export const updateClientMonthlyBudget = (token, organizationId, payload) => {
  const requestUrl = `${TTP_API_URL}/team/client/save-month-budget`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("clientId", payload.clientId);
  formData.append("organizationId", organizationId);
  formData.append("economicBudget", JSON.stringify(payload.economicBudget));
  formData.append("hourBudget", JSON.stringify(payload.hourBudget));
  formData.append("year", payload.year);

  return axios.post(requestUrl, formData);
};
